// extracted by mini-css-extract-plugin
export default {"root":"style_root__7P3k-","card":"style_card__prckJ","mark":"style_mark__eBA6c","title":"style_title__fcw9F","text":"style_text__G170P","hint":"style_hint__ANHRx"};